"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElectronicMedicalRecordSystem = void 0;
exports.instanceOfElectronicMedicalRecordSystem = instanceOfElectronicMedicalRecordSystem;
exports.ElectronicMedicalRecordSystemFromJSON = ElectronicMedicalRecordSystemFromJSON;
exports.ElectronicMedicalRecordSystemFromJSONTyped = ElectronicMedicalRecordSystemFromJSONTyped;
exports.ElectronicMedicalRecordSystemToJSON = ElectronicMedicalRecordSystemToJSON;
exports.ElectronicMedicalRecordSystemToJSONTyped = ElectronicMedicalRecordSystemToJSONTyped;
/**
 *
 * @export
 */
exports.ElectronicMedicalRecordSystem = {
    Allscripts: 'ALLSCRIPTS',
    AthenaHealth: 'ATHENA_HEALTH',
    Cerner: 'CERNER',
    Epic: 'EPIC',
    Meditech: 'MEDITECH',
    Mckesson: 'MCKESSON',
    Myavatar: 'MYAVATAR',
    Other: 'OTHER'
};
function instanceOfElectronicMedicalRecordSystem(value) {
    for (const key in exports.ElectronicMedicalRecordSystem) {
        if (Object.prototype.hasOwnProperty.call(exports.ElectronicMedicalRecordSystem, key)) {
            if (exports.ElectronicMedicalRecordSystem[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ElectronicMedicalRecordSystemFromJSON(json) {
    return ElectronicMedicalRecordSystemFromJSONTyped(json, false);
}
function ElectronicMedicalRecordSystemFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ElectronicMedicalRecordSystemToJSON(value) {
    return value;
}
function ElectronicMedicalRecordSystemToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=ElectronicMedicalRecordSystem.js.map